<template>
  <div :class="$style.contact">
    <div :class="$style.photoWrapper">
      <div :class="$style.photoContainer">
        <img :src="contactPhotoUrl" alt="" />
      </div>
    </div>
    <h5 :class="$style.contactName">{{contactName || contactNumber}}</h5>
    <p v-if="contactPosition" :class="$style.contactPosition">{{contactPosition}}</p>
    <p v-if="contactOrganization" :class="$style.contactOrganization">{{contactOrganization}}</p>
    <h5 v-if="contactName" :class="$style.contactPhone">{{contactNumber}}</h5>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const { mapGetters } = createNamespacedHelpers('conference')

  export default {
    computed: mapGetters([
      'contactName',
      'contactPhotoUrl',
      'contactPosition',
      'contactOrganization',
      'contactNumber'
    ])
  }
</script>

<style module src="./contact-info.css"></style>



// WEBPACK FOOTER //
// contact-info.vue?6c311499